var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInstagram = function SvgInstagram(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20311_98194)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0943 15.287C21.0943 18.3472 18.6142 20.8189 15.554 20.8189H8.66011C5.59991 20.8189 3.11979 18.3388 3.11979 15.287V8.39316C3.11979 5.34136 5.59991 2.86125 8.66011 2.86125H15.5624C18.6226 2.86125 21.1027 5.34136 21.1027 8.39316V15.287H21.0943ZM16.3779 0.72583H7.83621C4.05299 0.72583 0.984375 3.79444 0.984375 7.57767V16.1109C0.984375 19.8942 4.05299 22.9544 7.83621 22.9544H16.3779C20.1611 22.9544 23.2297 19.8857 23.2297 16.1109V7.57767C23.2297 3.79444 20.1611 0.72583 16.3779 0.72583Z",
    fill: "url(#paint0_linear_20311_98194)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4067 15.3964C10.4562 15.3964 8.88407 13.8159 8.88407 11.8738C8.88407 9.92338 10.4646 8.35124 12.4067 8.35124C14.3571 8.35124 15.9293 9.92338 15.9293 11.8738C15.9293 13.8243 14.3487 15.3964 12.4067 15.3964ZM12.4067 6.02246C9.16991 6.02246 6.54688 8.6455 6.54688 11.8738C6.54688 15.1022 9.16991 17.7252 12.4067 17.7252C15.6434 17.7252 18.2665 15.1022 18.2665 11.8738C18.2665 8.6455 15.6434 6.02246 12.4067 6.02246Z",
    fill: "url(#paint1_linear_20311_98194)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0417 5.82065C19.0417 6.62774 18.3859 7.27509 17.5873 7.27509C16.7802 7.27509 16.1328 6.62774 16.1328 5.82065C16.1328 5.01356 16.7802 4.36621 17.5873 4.36621C18.3859 4.36621 19.0417 5.02197 19.0417 5.82065Z",
    fill: "url(#paint2_linear_20311_98194)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20311_98194",
    x1: 22.3938,
    y1: 1.9822,
    x2: 4.33051,
    y2: 19.2929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6968DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3855,
    stopColor: "#D22A9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD879"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20311_98194",
    x1: 22.5535,
    y1: 2.15214,
    x2: 4.49023,
    y2: 19.4627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6968DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3855,
    stopColor: "#D22A9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD879"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20311_98194",
    x1: 22.0101,
    y1: 1.58319,
    x2: 3.9468,
    y2: 18.8939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6968DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3855,
    stopColor: "#D22A9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD879"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20311_98194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.2453,
    height: 22.2285,
    fill: "white",
    transform: "translate(0.984375 0.72583)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInstagram);
export default ForwardRef;